import { QuestionTypeName } from '../classes/learnware/LearnwareEnums';
export function getPackagesNamesForSerialized(ser) {
    if (ser.type === 'question' && [QuestionTypeName.Read, QuestionTypeName.Talk].includes(ser.questionType)) {
        return ['Exotic'];
    }
    if (ser.type === 'question' &&
        [
            QuestionTypeName.KnowAWord,
            QuestionTypeName.Associate,
            QuestionTypeName.CycleEnd,
            QuestionTypeName.MemorizePoints,
            QuestionTypeName.ThinkAndReveal,
            QuestionTypeName.Sortable,
            QuestionTypeName.MultiSelect,
        ].includes(ser.questionType)) {
        return ['Rare'];
    }
    return [];
}
export const inPackage = {
    trait: {
        tooltip: 'Lazy',
    },
    skeleton: {
        aspectTooltip: 'Lazy',
        aspectPopover: 'Lazy',
        defaultSoundStructure: 'Rare',
        defaultVideoStructure: 'Rare',
    },
};
